import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// services
import { recoverPuntoVentasDeleted } from '../../Services/puntoVentaService'

// Sweet alert
import Swal from 'sweetalert2'

// router
import { withRouter } from 'react-router-dom'

const ItemPuntoVentaEliminada = ({ puntoVenta, setIsLoad }) => {
    const recoverPuntoVentaSubmit = (puntoVenta) => {
        Swal.fire({
            title: 'Estas seguro de recuperarlo?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                recoverPuntoVentasDeleted(puntoVenta.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'El punto de venta fue recuperado.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{puntoVenta.id}</th>
            <td>{puntoVenta.nombre}</td>
            <td>{puntoVenta.ip || 'NO'}</td>
            <td>{puntoVenta.sucursal.nombre}</td>
            <td>
                {puntoVenta.datoFiscal
                    ? puntoVenta.datoFiscal.razonSocial
                    : 'NO'}
            </td>
            <td>{puntoVenta.puntoVenta || 'NO'}</td>{' '}
            {/* Nueva columna agregada */}
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverPuntoVentaSubmit(puntoVenta)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemPuntoVentaEliminada)
